// extracted by mini-css-extract-plugin
export default {"carInformationCard":"XRKnglS0ogcNH6AC3Pes","heading":"nrwHJXzg_tNTkftFyF3G","subheading":"oJqxC4Fe9sNOzObFRD2l","error":"ksKWRDkjL62nw0flbHtD"};